import { Collapse } from 'bootstrap';

const initMuAccordion = () => {
    const collapseInstances = new Map();

    const getCollapseInstance = (target) => {
        const id = `#${target.id}`;
        if (!collapseInstances.has(id)) {
            const instance = new Collapse(target, { toggle: false });
            collapseInstances.set(id, instance);

            target.addEventListener('shown.bs.collapse', () => {
                console.log(`${id} is now shown`);
            });
            target.addEventListener('hidden.bs.collapse', () => {
                console.log(`${id} is now hidden`);
            });
        }
        return collapseInstances.get(id);
    };

    const closeSiblings = (target) => {
        const parent = target.closest('.mu-accordion, .mu-footer-nav');
        if (!parent) return;

        parent.querySelectorAll('.collapse.show').forEach(openPanel => {
            if (openPanel === target || target.contains(openPanel)) return;

            const instance = getCollapseInstance(openPanel);
            instance.hide();

            const openButton = parent.querySelector(`[data-bs-target="#${openPanel.id}"]`);
            if (openButton) {
                openButton.setAttribute('aria-expanded', 'false');
                openButton.classList.add('collapsed');

                const icon = openButton.querySelector('.mu-btn--toggle');
                icon?.classList.add('collapsed');
            }
        });
    };

    const closeNavSiblings = (button) => {
        const currentItem = button.closest('li');
        const parentList = currentItem?.parentElement;
        if (!parentList || !currentItem) return;

        parentList.querySelectorAll(':scope > li').forEach(sibling => {
            if (sibling === currentItem) return;

            const openPanel = sibling.querySelector('ul.collapse.show');
            if (openPanel) {
                const instance = getCollapseInstance(openPanel);
                instance.hide();

                const openButton = sibling.querySelector(`[data-bs-target="#${openPanel.id}"]`);
                if (openButton) {
                    openButton.setAttribute('aria-expanded', 'false');
                    openButton.classList.add('collapsed');

                    const icon = openButton.querySelector('.mu-btn--toggle');
                    icon?.classList.add('collapsed');
                }
            }
        });
    };

    // Handle .mu-btn--toggle (nav accordion)
    document.querySelectorAll('main .mu-nav-accordion .mu-btn--toggle').forEach(button => {
        const targetSelector = button.getAttribute('data-bs-target');
        if (!targetSelector) return;

        const target = document.querySelector(targetSelector);
        if (!target) return;

        const collapseInstance = getCollapseInstance(target);

        button.addEventListener('click', (e) => {
            e.preventDefault();

            const isShown = target.classList.contains('show');

            if (isShown) {
                collapseInstance.hide();
                button.setAttribute('aria-expanded', 'false');
                button.classList.add('collapsed');

                // Collapse all nested children
                target.querySelectorAll('.collapse.show').forEach(nested => {
                    const nestedId = nested.id;
                    if (!nestedId) return;

                    const nestedInstance = getCollapseInstance(nested);
                    nestedInstance.hide();

                    const nestedButton = document.querySelector(`[data-bs-target="#${nestedId}"]`);
                    if (nestedButton) {
                        nestedButton.setAttribute('aria-expanded', 'false');
                        nestedButton.classList.add('collapsed');
                    }
                });

                console.log(`${targetSelector} collapsed`);
            } else {
                closeNavSiblings(button); // close siblings at same level
                collapseInstance.show();
                button.setAttribute('aria-expanded', 'true');
                button.classList.remove('collapsed');
                console.log(`${targetSelector} expanded`);
            }
        });
    });

    // Handle .mu-accordion-button (list accordion)
    document.querySelectorAll('.mu-accordion-button').forEach(button => {
        const targetSelector = button.getAttribute('data-bs-target');
        const target = document.querySelector(targetSelector);
        const icon = button.querySelector('.mu-btn--toggle');
        if (!target) return;

        const collapseInstance = getCollapseInstance(target);

        button.addEventListener('click', (e) => {
            e.preventDefault();

            const isShown = target.classList.contains('show');

            if (isShown) {
                collapseInstance.hide();
                button.setAttribute('aria-expanded', 'false');
                icon?.classList.add('collapsed');
            } else {
                closeSiblings(target);
                collapseInstance.show();
                button.setAttribute('aria-expanded', 'true');
                icon?.classList.remove('collapsed');
            }

            console.log(`${targetSelector} clicked`);
        });
    });

    // Handle .mu-footer-nav-toggle (footer accordion)
    document.querySelectorAll('.mu-footer-nav-toggle').forEach(button => {
        const targetSelector = button.getAttribute('data-bs-target');
        if (!targetSelector) return;

        const target = document.querySelector(targetSelector);
        if (!target) return;

        const collapseInstance = getCollapseInstance(target);

        button.addEventListener('click', (e) => {
            e.preventDefault();

            const isShown = target.classList.contains('show');

            if (isShown) {
                collapseInstance.hide();
                button.setAttribute('aria-expanded', 'false');
                button.classList.add('collapsed');
            } else {
                closeSiblings(target);
                collapseInstance.show();
                button.setAttribute('aria-expanded', 'true');
                button.classList.remove('collapsed');
            }

            console.log(`${targetSelector} clicked`);
        });
    });
};

export default initMuAccordion;